/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Online_AInputs */

const en_wc_faq_online_a = /** @type {(inputs: Wc_Faq_Online_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click “Try WordCraft here” to load the browser editor on this homepage, or open it in a separate tab. The editor runs in your browser, opens local documents and saves your work to your device. Save before closing the page; this site does not provide document cloud storage.`)
};

/**
* | output |
* | --- |
* | "Click “Try WordCraft here” to load the browser editor on this homepage, or open it in a separate tab. The editor runs in your browser, opens local documents ..." |
*
* @param {Wc_Faq_Online_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_online_a = /** @type {((inputs?: Wc_Faq_Online_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Online_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_online_a(inputs)
});
export { wc_faq_online_a as "wc.faq.online.a" }